var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14095",
    "data-name": "Grupo 14095",
    transform: "translate(-1432.5 -2573.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_6",
    "data-name": "Pol\\xEDgono 6",
    d: "M24.7,2.143A4.505,4.505,0,0,1,30.773,3.77h0a4.505,4.505,0,0,0,3.812,2.2h0a4.505,4.505,0,0,1,4.445,4.445h0a4.505,4.505,0,0,0,2.2,3.812h0A4.505,4.505,0,0,1,42.857,20.3h0a4.505,4.505,0,0,0,0,4.4h0a4.505,4.505,0,0,1-1.627,6.072h0a4.505,4.505,0,0,0-2.2,3.812h0a4.505,4.505,0,0,1-4.445,4.445h0a4.505,4.505,0,0,0-3.812,2.2h0A4.505,4.505,0,0,1,24.7,42.857h0a4.505,4.505,0,0,0-4.4,0h0a4.505,4.505,0,0,1-6.072-1.627h0a4.505,4.505,0,0,0-3.812-2.2h0a4.505,4.505,0,0,1-4.445-4.445h0a4.505,4.505,0,0,0-2.2-3.812h0A4.505,4.505,0,0,1,2.143,24.7h0a4.505,4.505,0,0,0,0-4.4h0A4.505,4.505,0,0,1,3.77,14.227h0a4.505,4.505,0,0,0,2.2-3.812h0a4.505,4.505,0,0,1,4.445-4.445h0a4.505,4.505,0,0,0,3.812-2.2h0A4.505,4.505,0,0,1,20.3,2.143h0a4.505,4.505,0,0,0,4.4,0Z",
    transform: "translate(1432.5 2573.5)",
    fill: "#ec0818"
  }), /*#__PURE__*/React.createElement("text", {
    id: "NOVO",
    transform: "translate(1455.5 2600.5)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14,
    y: 0
  }, "NOVO")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelNew);
export default __webpack_public_path__ + "static/media/labelNew.a1380d548fd322c33da88c5cdfe5fc8f.svg";
export { ForwardRef as ReactComponent };